// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jAlBlktkjv1sl2PGjFFN {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    padding: 16px 32px;
    border-bottom: 1px solid #E5E5E5;
}

.jAlBlktkjv1sl2PGjFFN p {
    margin: 0;
}


.xZs6T6UT8G3v1Zxr321b {
    font-family: "Fjalla One", sans-serif;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    font-size: 24px;
}

.suRdkICxD_qQiyOy0_h9 {
    margin-left: 8px;
}

.zYbU9fmH8zeegSgx6_oy {
    display: flex;
    align-items: center;

    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    text-decoration: none;
    font-weight: 500;

    transition: .3s;
}

.zYbU9fmH8zeegSgx6_oy:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]};
}

.zYbU9fmH8zeegSgx6_oy span {
    margin: 0 0 0 4px;
}

@media screen and (max-width: 425px) {
    .jAlBlktkjv1sl2PGjFFN {
        padding: 16px;
    }

    .suRdkICxD_qQiyOy0_h9 {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardHeader/DashboardHeader.module.css"],"names":[],"mappings":"AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;;IAEnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,SAAS;AACb;;;AAGA;IACI,qCAAqC;IACrC,mDAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,mDAAmB;IACnB,qBAAqB;IACrB,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA;IACI,mDAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@value colors: \"../../../components/library/style/colors.css\";\n@value color-purple, color-purple-dark from colors;\n\n.header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    padding: 16px 32px;\n    border-bottom: 1px solid #E5E5E5;\n}\n\n.header p {\n    margin: 0;\n}\n\n\n.dot {\n    font-family: \"Fjalla One\", sans-serif;\n    color: color-purple;\n    font-size: 24px;\n}\n\n.space {\n    margin-left: 8px;\n}\n\n.links {\n    display: flex;\n    align-items: center;\n\n    color: color-purple;\n    text-decoration: none;\n    font-weight: 500;\n\n    transition: .3s;\n}\n\n.links:hover {\n    color: color-purple-dark;\n}\n\n.links span {\n    margin: 0 0 0 4px;\n}\n\n@media screen and (max-width: 425px) {\n    .header {\n        padding: 16px;\n    }\n\n    .space {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]}`,
	"header": `jAlBlktkjv1sl2PGjFFN`,
	"dot": `xZs6T6UT8G3v1Zxr321b`,
	"space": `suRdkICxD_qQiyOy0_h9`,
	"links": `zYbU9fmH8zeegSgx6_oy`
};
export default ___CSS_LOADER_EXPORT___;
